/** Student sign-up (owner decision 2026-11-03): how many times the daily memorization the cumulative review is. */
import { useState, type FormEvent } from "react";
import { useQueryClient } from "@tanstack/react-query";
import type { RegistrationSetting } from "@mubin/contracts";
import { ErrorNote, Field, useSubmit } from "./ui";
import { errorText, send } from "../lib/api";

export function RegistrationCard({
  organizationId,
  value,
}: {
  organizationId: string;
  value: RegistrationSetting;
}) {
  const qc = useQueryClient();
  const { busy, error, run } = useSubmit();
  const [multiple, setMultiple] = useState(value.reviewMultiple);
  const [saved, setSaved] = useState(false);
  const changed = multiple !== value.reviewMultiple;

  function save(e: FormEvent) {
    e.preventDefault();
    setSaved(false);
    void run(async () => {
      await send("PATCH", `/v1/organizations/${organizationId}/settings`, {
        registration: { reviewMultiple: multiple },
      });
      await qc.invalidateQueries({ queryKey: ["organizations"] });
      setSaved(true);
    }, errorText);
  }

  return (
    <section className="card">
      <div className="card-h">
        <h2>تسجيل الطلاب</h2>
      </div>
      <form className="form section" onSubmit={save}>
        <p className="muted small">
          يسجّل الطالب من التطبيق ويختار خطته. إذا اختار المراجعة التراكمية فمقدارها اليومي أضعاف حفظه اليومي:
          تدور على ما حفظه في خطته من أوله حتى تصل الجديد، ثم تبدأ من الأول.
        </p>
        <Field
          id="reg-multiple"
          label="مقدار المراجعة التراكمية (أضعاف الحفظ اليومي)"
          hint={`مثال: من يحفظ وجهًا يراجع ${multiple.toLocaleString("ar-SA")} أوجه. يسري على من يُسند بعد الحفظ.`}
        >
          <select id="reg-multiple" value={multiple} onChange={(e) => setMultiple(Number(e.target.value))}>
            {[1, 2, 3, 4, 5, 6, 8, 10].map((n) => (
              <option key={n} value={n}>
                {n.toLocaleString("ar-SA")} {n === 1 ? "ضعف" : n <= 10 ? "أضعاف" : "ضعفًا"}
              </option>
            ))}
          </select>
        </Field>
        <ErrorNote error={error} />
        {saved && !changed && <p className="muted small">حُفظ.</p>}
        <div className="form-actions">
          <button className="btn btn-primary" disabled={busy || !changed}>
            {busy ? "جارٍ الحفظ…" : "حفظ"}
          </button>
        </div>
      </form>
    </section>
  );
}
